<section class="items-card">
  <ul class="items-card__list">
    <!-- component -->
    <li class="items-card__item" *ngFor="let cartItem of cart.items">
      <img
        class="items-card__item__image"
        [src]="cartItem.thumbnail_url"
        [alt]="cartItem.name"
      />
      <div ngClass="items-card__item__content-holder">
        <div ngClass="items-card__item__content">
          <div>
            <app-raffle-instant-logo
              [instantType]="cartItem.item_data.instant_type"
              *ngIf="cartItem.item_data.instant"
              [size]="'small'"
            ></app-raffle-instant-logo>
            <h4 class="items-card__item__title">{{ cartItem.name }}</h4>
            <span
              *ngIf="cartItem.description"
              class="items-card__item__description"
            >
              {{ cartItem.description }}
            </span>
          </div>
          <div ngClass="items-card__item__prices">
            <span
              *ngIf="cartItem.discount > 0"
              class="items-card__item__original"
            >
              {{
                cartItem.discount * cartItem.quantity | currency: cart.currency
              }}
            </span>
            <span class="items-card__item__discount">
              {{
                cartItem.single_price * cartItem.quantity
                  | currency: cart.currency
              }}
            </span>
          </div>
        </div>
        <div ngClass="items-card__item__actions">
          <!-- warning to display erros on the raffle -->
          <span
            *ngIf="
              warnMaxTicket[cartItem.type_id1] &&
              warnMaxTicket[cartItem.type_id1].show
            "
            class="items-card__item__actions__warning"
          >
            {{ getWarn(cartItem.type_id1).error }}
          </span>
          <div ngClass="items-card__item__actions__content">
            <div ngClass="items-card__item__actions__button-groups">
              <button
                ngClass="items-card__item__actions__button minus-button"
                (click)="
                  changeTickets(
                    cartItem.type_id1,
                    cartItem.id,
                    cartItem.quantity - 1
                  )
                "
                [disabled]="
                  minTickets[cartItem.type_id1] >= cartItem.quantity ||
                  isGettingTickets
                "
                >-
              </button>
              <input
                min="0"
                type="number"
                appOnlyNumbers
                ngClass="items-card__item__actions__input"
                (change)="
                  changeTickets(
                    cartItem.type_id1,
                    cartItem.id,
                    $event.target.value
                  )
                "
                [value]="cartItem.quantity"
                [disabled]="isGettingTickets"
              />
              <button
                ngClass="items-card__item__actions__button"
                (click)="
                  changeTickets(
                    cartItem.type_id1,
                    cartItem.id,
                    cartItem.quantity + 1
                  )
                "
                [disabled]="
                  maxTickets[cartItem.type_id1] <= cartItem.quantity ||
                  isGettingTickets
                "
              >
                +
              </button>
            </div>
            <button
              ngClass="items-card__item__actions__delete"
              [disabled]="isGettingTickets"
            >
              <img
                src="assets/svg-icons/delete.svg"
                alt="delete tag"
                (click)="changeTickets(cartItem.type_id1, cartItem.id, 0)"
              />
            </button>
          </div>
        </div>
      </div>
    </li>
    <ng-container *ngIf="hasPopupRaffle && rafflePopupInformation">
      <li class="items-card__item">
        <div ngClass="item-card__item__popup-raffle popup-holder">
          <span class="items-card__item__popup-raffle__title">
            Add another competition
          </span>
          <div ngClass="items-card__item__popup-raffle__content">
            <img
              [src]="rafflePopupInformation.thumbnail.thumbnail"
              alt="raffle thumbnail main card"
            />
            <div ngClass="info">
              <div>
                <app-raffle-instant-logo
                  [instantType]="rafflePopupInformation.instant_win_type"
                  *ngIf="rafflePopupInformation.instant"
                  [size]="'small'"
                ></app-raffle-instant-logo>
                <span class="subtitle">
                  {{ rafflePopupInformation.title }}
                </span>
                <span class="price">
                  {{
                    rafflePopupInformation.offers[0].price
                      | currency: cart.currency
                  }}
                </span>
              </div>
              <button (click)="addPopupRaffleToCart()"> + </button>
            </div>
          </div>
        </div>
      </li>
    </ng-container>
    <li
      ngClass="items-card__item token-card"
      *ngIf="selectedPaymentCard && selectedPaymentCard.id !== 'new'"
    >
      <div class="items-card__item__token-card">
        <div class="items-card__item__token-card__content">
          <span class="items-card__item__token-card__content__text">
            Paying with :
          </span>
          <span class="text-capitalize">
            {{ selectedPaymentCard.card_type }}
            {{ selectedPaymentCard.card_mask.slice(12, 16) }}
          </span>
        </div>
        <a
          class="items-card__item__token-card__button"
          (click)="handleShowTokenEditModal()"
        >
          Change payment method
        </a>
      </div>
      <div ngClass="items-card__item__token-card__image">
        <img
          *ngIf="selectedPaymentCard.card_type === 'visa'"
          src="assets/svg-icons/visa-white.svg"
          alt="edit tag"
        />
        <img
          *ngIf="selectedPaymentCard.card_type === 'master'"
          src="assets/svg-icons/mastercard-white.svg"
          alt="edit tag"
        />
      </div>
    </li>
    <li
      ngClass="items-card__item token-card"
      *ngIf="selectedPaymentCard?.id === 'new'"
    >
      <div class="items-card__item__token-card">
        <div class="items-card__item__token-card__content">
          <span class="items-card__item__token-card__content__text">
            Add new card
          </span>
        </div>
        <a
          class="items-card__item__token-card__button"
          (click)="changePaymentMethod(true)"
        >
          Change payment card
        </a>
      </div>
    </li>
  </ul>
</section>
